module.exports = __webpack_public_path__ + "img/icon-payment.2833560d.png";